// Constants
import Endpoints from '@/constants/endpoints';
import Constants from '@/constants/constants';

// Services
import $http from '@/core/services/http.service';


export default class BudgetService {
    public static budgetParticipantList(budgetId: string) {
        return $http.get(Endpoints.budgetParticipantList(budgetId));
    }

    public static generateRemittance(from: string, to: string, date: string) {
        return $http.post(Endpoints.remittance, {
            startDate: from,
            endDate: to,
            collectionDate: date,
        });
    }

    public static validateBudgetNif(budgetId: string, nif: string) {
        return $http.post(Endpoints.budgetMandateAuth(budgetId), { nif });
    }

    public static remittanceDocument(remittanceId: string) {
        return Endpoints.remittanceDocument(remittanceId);
    }

    public static sendAcceptanceEmail(budgetId: string) {
        return $http.post(Endpoints.budgetAcceptanceSend(budgetId));
    }

    public static sendValidationEmail(budgetId: string) {
        return $http.post(Endpoints.budgetValidationSend(budgetId));
    }

    public static sendDocumentEmail(budgetId: string) {
        return $http.post(Endpoints.budgetDocumentSend(budgetId));
    }

    public static signMandate(budgetId: string, data: any) {
        return $http.patch(Endpoints.budgetMandateSign(budgetId), data);
    }

    public static checkMandateSignStatus(budgetId: string) {
        return $http.get(Endpoints.budgetMandateSignStatus(budgetId));
    }

    public static rejectBudget(budgetId: string) {
        return $http.post(Endpoints.rejectBudget(budgetId));
    }

    public static downloadCsv(filters: any): void {
        const baseUrl = process.env.VUE_APP_BASE_URI_API;
        const baseEndpoint = `${Endpoints.budget}`;
        let params = `?limit=${Constants.downloadCsvLimit}`;
        params += `&search=${filters.search}`;
        if (filters.dateFrom) {
            params += `&date_from=${filters.dateFrom}`;
        }

        if (filters.dateTo) {
            params += `&date_to=${filters.dateTo}`;
        }
        params += `&fiscal_data=${filters.fiscalData}`;
        const url = `${baseUrl}${baseEndpoint}csv/${params}`;
        window.location.href = url;
    }

}
